import { memo } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import type { Option } from "types";
import DepartmentSelector from "ui/molecules/DeparmentSelector";
import useSupport from "./useSupport";
import { getFormInputProps } from "util/forms";
import type { SupportFormProps } from "./types";
import { FormFields } from "./validators";

const Support = (props: SupportFormProps) => {
    const {
        errors,
        values,
        touched,
        isSubmitting,
        isValid,
        setFieldValue,
        handleSubmit,
        handleChange,
        handleBlur
    } = useSupport(props);

    const onDepartmentChange = ({ id }: Option) =>
        setFieldValue(
            FormFields.Department,
            `${id}`,
            true
        );

    return (
        <Box
            noValidate
            component='form'
            name='feedback'
            autoComplete="off"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: 3
            }}
        >
            <TextField
                {...getFormInputProps(FormFields.Subject, { errors, touched })}
                fullWidth
                label='Subject'
                name={FormFields.Subject}
                value={values[FormFields.Subject]}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <DepartmentSelector
                {...getFormInputProps(FormFields.Department, { errors, touched })}
                fullWidth
                label='Select department'
                name={FormFields.Department}
                value={values[FormFields.Department]}
                onChange={onDepartmentChange}
                onBlur={handleBlur}
            />
            <TextField
                {...getFormInputProps(FormFields.Description, { errors, touched })}
                multiline
                fullWidth
                rows={6}
                placeholder='Type your message here...'
                name={FormFields.Description}
                value={values[FormFields.Description]}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <LoadingButton
                variant='outlined'
                type='submit'
                disabled={!isValid}
                loading={isSubmitting}
            >
                Send
            </LoadingButton>
        </Box>
    );
};

export default memo(Support);
